<script lang="ts">
  import { initializeProductFruits } from "services/productFruitsService";
  import { onMount } from "svelte";

  onMount(initializeProductFruits);
</script>
